import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import Multiselect from 'vue-multiselect'

export default {
	name: 'AWBVerificationMapping',
	components: {
		BasicSelect,
		VueElementLoading,
		Multiselect

	},
	props: [],
	data() {
		return {
			isLoading: false,
			hubzoneid: '',
			HubID: '',
			hubname: '',
			DesHubID: '',
			DestHubName:'',
			listSourceHubNameData: [],
			hubListObjData: [],
			listHubZoneData: [],
			newParentHubData:[],
			listComboHubDetails: {},
			tableData:false,
			listSourceHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			listSourceHubNameDataObj2: {
				value: "",
				text: "",
			},
			listHubZoneObjData: {
				value: "",
				text: ""
			},
			HubZoneObjData:{
				value: "",
				text: ""
			},
			newParentHubObjData:{
				value:"",
				text:""
			},
			hubLoading: '',
			dtoSourceHub:{},
			newParentHub:'',
			isactive:'',
			isVerification:true,
			isOrigin:false,
			isVerificationHubError:'',
			hubVerificationPalletizationId:'',
			isRestrict:false,
			isRestrictUp:false,
			verificationhubArr:[],
			HubIDArr:[],
			DesHubIDArr:[]
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.getHubZoneData();
	},
	methods: {
		selectedHubzone(hubData) {
			this.listHubZoneObjData = hubData
			this.hubzoneid = hubData.value;
			this.hubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: '',
				hubcode: ''
			}
			this.HubID = ''
			this.listSourceHubNameDataObj2 = {
				text: '',
				value: ''
			}
			this.DesHubID = ''
			this.$validator.reset()
			this.tableData = false
			this.HubIDArr=[]
			if (this.hubzoneid != undefined) {
				this.getSourceHubNameList(this.hubzoneid)
			}
		},
		selectedNewParentHub(hubData) {
			this.newParentHubObjData = hubData
			this.newParentHubId = hubData.value;
			this.newParentHubName = hubData.text;
			this.newParentHub = hubData.text1
			this.$validator.reset()
		},
		selectedSourceHubName2(selectedData) {
			this.listSourceHubNameDataObj2 = selectedData
			this.DesHubID = selectedData.value;
			this.DestHubName = selectedData.text1;
			if (this.DesHubID != '') {
				this.isVerificationHubError=''
			}
		},
		selectedHubName(selectedData) {
			this.hubListObjData = selectedData
			this.HubID = selectedData.value;
			this.HubName = selectedData.text;
			this.getAllHubs();
		},
		selectedSourceHubName(selectedData) {
			this.HubID = ''
			this.listSourceHubNameDataObj = selectedData
			this.HubID = selectedData.value;
			this.hubname = selectedData.text1;
			this.$validator.validate('SourceHub')
		},
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},
		getSourceHubNameList() {
			this.hubLoading = 'Loading Hub...'
			this.listSourceHubNameData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubNameData = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameData.length; i++) {
						this.listSourceHubNameData.push({
							value: listSourceHubNameData[i].HubID,
							text: listSourceHubNameData[i].HubCode + ' - ' + listSourceHubNameData[i].HubName + ' (' + listSourceHubNameData[i].HubID + ')',
							text1: listSourceHubNameData[i].HubName,
							hubcode: listSourceHubNameData[i].HubCode
						})
						this.newParentHubData.push({
							value: listSourceHubNameData[i].HubID,
							text: listSourceHubNameData[i].HubName+ ' (' + listSourceHubNameData[i].HubID + ')'
						})
					}
				}, error => {
					console.error(error)
				})
		},
		toggleIsOrigin(){
			if(this.isOrigin == true){
				this.isVerification=true
				this.listSourceHubNameDataObj2 = {
					value: '',
					text: ''
				}
				this.DesHubID=''
				this.isVerificationHubError=''
			}
		},
		addDTOBagProcessingHubDetail() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.verificationhubArr = [];
			if(this.isOrigin==false && this.DesHubID == ''){
				this.isVerificationHubError = 'The Verification Hub Name field is required.'
				return false;
			}
			this.input = {
				originHub: this.HubID,
				isChecked:this.isOrigin,
				isVerificationEnabled:this.isOrigin,
	      createdBy : this.useremail,
				isPalletizationEnabled:false,
				isRestrict:this.isRestrict
			}
			if(this.DesHubID!=''){
				this.input.verificationHub=this.DesHubID
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'addVerificationPalletizationEnabled',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.tableData = true
						this.$alertify.success(result.data.ReturnMessage)
						this.listComboHubDetails = result.data.ResponseData[0];

						this.dtoSourceHub={dtoSourceHubID:this.listComboHubDetails.originhub,dtoSourceHubName:this.listComboHubDetails.originHubName}

						document.getElementById("isactive").checked = this.listComboHubDetails.isactive;
						document.getElementById("isRestrictUp").checked = this.listComboHubDetails.isrestrict;

						 this.verificationhubArr = {text:this.listComboHubDetails.verificationHubName+ ' (' + this.listComboHubDetails.verificationhub+ ')' ,value:this.listComboHubDetails.verificationhub}
						 this.newParentHubData.unshift(this.verificationhubArr)

						 this.newParentHubData = this.newParentHubData.filter((value, index, self) =>
						 index === self.findIndex((t) => (
							 t.value === value.value && t.text === value.text
						   )))
						 this.newParentHubObjData = this.newParentHubData[0]
						 this.newParentHub = this.listComboHubDetails.dtobagparenthubname
					} else if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
					}else if (response.data.ResultCode == 401) {
						this.$alertify.error(result.data.ReturnMessage)
					}else{
						this.$alertify.error(result.data.ReturnMessage)
						this.resetForm();
						this.listComboHubDetails = '';
					}
				}, error => {
					self.isLoadingSearch = false;
					this.$alertify.error("Fetch Connection API error")
					console.error(error)
				})
		},
		updateHubDetails(){
			let isVerificationEnabled = false;
			if(!this.newParentHubObjData.value) return this.$alertify.error('Verification Hub field is required.');

			if (this.dtoSourceHub.dtoSourceHubID == this.newParentHubObjData.value) {
				isVerificationEnabled = true;
			}
			if(document.getElementById("isactive").checked == true){
				this.isactive = 1
			}else{
				this.isactive = 0
			}
			this.input = {
				hubVerificationPalletizationId:this.listComboHubDetails.hubverificationpalletizationid,
				originHub:this.dtoSourceHub.dtoSourceHubID,
				verificationHub: this.newParentHubObjData.value,
	      isVerificationEnabled: isVerificationEnabled,
				isActive: this.isactive,
	      updatedBy : this.useremail,
	      isRestrict : this.isRestrictUp
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'updateVerificationPalletizationEnabled',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.resetForm();
					} else if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
					}else if (response.data.ResultCode == 401) {
						this.$alertify.error(result.data.ReturnMessage)
					}else{
						this.$alertify.error(result.data.ReturnMessage)
						this.resetForm();
					}
				}, error => {
					self.isLoadingSearch = false;
					this.$alertify.error("Fetch Connection API error")
					console.error(error)
				})
		},
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						if(this.isOrigin==false && this.DesHubID == ''){
							this.isVerificationHubError = 'The Verification Hub Name field is required.'
							return false;
						}
						console.log('errors exist', this.errors);
						return false;
					} else {
						this.addDTOBagProcessingHubDetail();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		resetForm() {
		  this.isLoading=false
		  this.isOrigin=false
		  this.isVerification=true
		  this.isVerificationHubError = ''
		  this.hubVerificationPalletizationId = ''
		  this.hubzoneid=''
		  this.HubID=''
		  this.hubname=''
		  this.DesHubID=''
		  this.DestHubName='',
		  this.hubListObjData=[]
		  this.listSourceHubNameDataObj = {
		    value: '',
		    text: '',
		    hubcode: ''
		  };
		  this.listHubZoneObjData = {
		    value: '',
		    text: ''
		  };
		  this.tableData=false
		  this.listResultHubobjData = {
		    value: '',
		    text: ''
		  };
		  this.listSourceHubNameDataObj2 = {
		    value: '',
		    text: ''
		  }
		  this.hubLoading=''
		  this.routetypeitem = {
		      id: '',
		      text: ''
		    },
		  this.newParentHubData=[]
		  this.newParentHubObjData={
		    value: '',
		    text: ''
		  }
		  this.dtoSourceHub={}
		  this.newParentHub=''
		  this.routetype = '';
		  this.connectiontype = '';
		  this.connectionname = '';
		  this.resultHubID = '';
		  this.ConnectionID = '';
		  this.listSourceHubNameData = []
		  this.listComboHubDetails = []
		  this.isRestrict = false
		  this.isRestrictUp = false
		  this.isactive=''
		  this.verificationhubArr=[]
		  this.$validator.reset();
		  this.HubIDArr=[];
		  this.DesHubIDArr=[]
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/AWBVerificationMapping/AWBVerificationMapping.js